import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})

export class AnimationService {

  public holdMainHeight$ = new BehaviorSubject(false);

  constructor(
  ) {}

  public holdMainHeight = (hold: boolean): void => {
    this.holdMainHeight$.next(hold);
  }

}